import React from 'react';
import { CtaButton } from './CtaButton';
import { RatingProof } from './RatingProof';
import { heroImage } from '../data/product';

// Chip dots echo the volume colors on the covers.
const chips = [{
  label: '6 Volumes',
  dot: 'bg-coral'
}, {
  label: '72 Sessions',
  dot: 'bg-gold'
}, {
  label: '36 Themes',
  dot: 'bg-sage'
}, {
  label: '432 Ready Targets',
  dot: 'bg-smoke'
}, {
  label: '5 Bonuses',
  dot: 'bg-plum'
}];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Use on screen or print once in B&W'];

/**
 * One centered column at every width so the wide six-volume photo can run
 * large. Order: headline → photo → CTA → proof → details.
 */
export function Hero() {
  return <section className="w-full bg-cream" data-id="element-117" data-mp="nb6mdr96tjnm">
      <div className="max-w-6xl mx-auto px-5 pt-6 pb-12 sm:pt-12 sm:pb-20" data-id="element-118" data-mp="neknkw647mth">
        <header className="mx-auto max-w-3xl text-center" data-id="element-119" data-mp="3d33d6tuq0lin">
          <p className="text-[11px] sm:text-[12px] font-bold uppercase tracking-[1.4px] text-coral-deep" data-id="element-120" data-mp="381xjaspbqs7j">
            For school &amp; pediatric SLPs
          </p>
          <h1 className="mt-3 font-display text-plum text-[34px] leading-[1.05] tracking-tight sm:text-5xl lg:text-[60px]" data-id="element-121" data-mp="3j6odfogqqus7">
            Walk into every mixed group{' '}
            <span className="text-smoke" data-id="element-122" data-mp="399tdd14tkmbt">already planned.</span>
          </h1>
        </header>

        <figure className="-mx-5 mt-6 sm:mx-0 sm:mt-10" data-id="element-123" data-mp="3e7uwfm28wlna">
          <img src={heroImage.src} alt={heroImage.alt} width={heroImage.width} height={heroImage.height} className="aspect-[1024/688] w-full object-cover sm:rounded-3xl sm:shadow-photo" data-id="element-124" data-mp="30hhp9lx6haz0" />
        </figure>

        <div className="mx-auto mt-6 max-w-xl text-center sm:mt-10" data-id="element-125" data-mp="2qi0lxb5ef967">
          <CtaButton data-id="element-126" data-mp="2vjg48vg6z1kw">Get Session Ready SLP</CtaButton>
          <ul className="mt-3 flex flex-wrap justify-center gap-x-4 gap-y-1.5 text-[12px] text-ink-soft" data-id="element-127" data-mp="2hinaicxpsaiu">
            {micro.map(item => <li key={item} className="flex items-center gap-1.5" data-id="element-128" data-mp="2lk8wcns87z56">
                <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-129" data-mp="s2b73w324f43" />
                {item}
              </li>)}
          </ul>

          <div className="mt-6 flex justify-center" data-id="element-130" data-mp="na09x0zpb7f8">
            <RatingProof data-id="element-131" data-mp="ibgmsx9dfpla" />
          </div>

          <p className="mt-6 text-base text-ink-soft sm:text-lg" data-id="element-132" data-mp="ichx2zikc81y">
            Six volumes of stacked speech therapy sessions for ages 5–11. One
            theme, one page, and a goal row for every student in the group —
            Sound, Word, Sentence and Social, each at three levels.
          </p>

          <ul className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-133" data-mp="15zq35jntfl51">
            {chips.map(chip => <li key={chip.label} className="flex items-center gap-2 rounded-full border border-cream-dark bg-white px-3 py-1.5 text-[12px] font-semibold text-ink" data-id="element-134" data-mp="114stcaipp7r3">
                <span className={`h-2 w-2 rounded-full ${chip.dot}`} aria-hidden="true" data-id="element-135" data-mp="3hrd80rmt53yb" />
                {chip.label}
              </li>)}
          </ul>

          <p className="mt-5 text-sm text-ink-muted" data-id="element-136" data-mp="21aeidfnb4ja3">
            One payment, no subscription. Works for SLPs, SLTs and S-LPs.
          </p>
        </div>
      </div>
    </section>;
}